export function notifyCameraTouchChange() { this._map.fire('cameratouchchange'); }
